export const frMovieMetaDesc = [
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et toutes les plateformes sur JustWatch.',
		v1_max_length: 138,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et toutes les plateformes sur JustWatch.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 123,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et toutes les plateformes sur JustWatch.',
		v1_max_length: 145,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, et la 4K sur JustWatch.',
		v2_max_length: 137,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 130,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et les plateformes sur JustWatch.',
		v1_max_length: 143,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, et la 4K sur JustWatch.',
		v2_max_length: 142,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 135,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et les plateformes sur JustWatch.',
		v1_max_length: 153,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, et la 4K sur JustWatch.',
		v2_max_length: 152,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 145,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 144,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Toutes les options dont VF, VOSTFR, gratuit et 4K.',
		v2_max_length: 145,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et 1 autre service. Comparez les options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 152,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre service. Toutes les options dont VF et gratuit.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et {{restCount}} autres services. Comparez les options VF, VOSTFR et gratuit.',
		v1_max_length: 153,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. Toutes les options dont VF.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres. Mis à jour le  {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et toutes les plateformes sur JustWatch.',
		v1_max_length: 147,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, gratuit, VOSTFR et 4K sur JustWatch.',
		v2_max_length: 135,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 132,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, le gratuit, la 4K et les plateformes sur JustWatch.',
		v1_max_length: 153,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et la 4K sur JustWatch.',
		v2_max_length: 145,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 139,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 135,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Streaming en VF, VOSTFR, gratuit, et en 4K sur JustWatch.',
		v2_max_length: 143,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 145,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR et gratuit sur JustWatch.',
		v2_max_length: 153,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 154,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 153,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR et gratuit.',
		v2_max_length: 147,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 162,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et 1 autre service. En options VF, VOSTFR, gratuit, 4K.',
		v1_max_length: 150,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre service. Options VF, VOSTFR et gratuit.',
		v2_max_length: 156,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre service. Mis à jour : {{lastUpdatedAt}}.',
		v3_max_length: 160,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et {{restCount}} autres services. En options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 158,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. En VF, gratuit.',
		v2_max_length: 147,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres services.',
		v3_max_length: 132,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K et les plateformes sur JustWatch.',
		v1_max_length: 151,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, gratuit, VOSTFR et 4K sur JustWatch.',
		v2_max_length: 146,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, et la 4K sur JustWatch.',
		v1_max_length: 145,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, gratuit, VOSTFR et 4K sur JustWatch.',
		v2_max_length: 153,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, et 4K sur JustWatch.',
		v1_max_length: 147,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR et gratuit.',
		v2_max_length: 140,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Options de streaming mises à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit, 4K sur JustWatch.',
		v1_max_length: 154,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR et gratuit.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 142,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. En options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 154,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF et gratuit.',
		v2_max_length: 150,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et 1 autre service. En VF, VOSTFR, gratuit.',
		v1_max_length: 148,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre service. En VF et gratuit.',
		v2_max_length: 155,
		v3_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, avec 1 autre service.',
		v3_max_length: 138,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}, et {{restCount}} autres services. Options VF et gratuit.',
		v1_max_length: 154,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres services. En VF, gratuit.',
		v2_max_length: 158,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres services.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K sur JustWatch.',
		v1_max_length: 154,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, VOSTFR et 4K sur JustWatch.',
		v2_max_length: 157,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 140,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Trouvez les options VF, VOSTFR, gratuit sur JustWatch.',
		v1_max_length: 154,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options VF, gratuit et VOSTFR.',
		v2_max_length: 155,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 148,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Trouvez les options VF, VOSTFR et gratuit.',
		v1_max_length: 147,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En VF, VOSTFR et 4K sur JustWatch.',
		v2_max_length: 151,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}. Trouvez les options VF et gratuit.',
		v1_max_length: 149,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En options VF et gratuit.',
		v2_max_length: 152,
		v3_translatable: 'Regardez "{{titleName}}" en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}. En options VF, VOSTFR et gratuit.',
		v1_max_length: 156,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En VF et gratuit.',
		v2_max_length: 152,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}, et 1 autre service.',
		v1_max_length: 145,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre service.',
		v2_max_length: 156,
		v3_translatable: 'Regardez "{{titleName}}" en ligne sur {{providerNames}}, avec 1 autre service.',
		v3_max_length: 148,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}, et {{restCount}} autres services.',
		v1_max_length: 150,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres.',
		v2_max_length: 153,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}, avec {{restCount}} autres services.',
		v3_max_length: 145,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 148,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Comparez les options, dont VF et gratuit.',
		v2_max_length: 154,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 148,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR, gratuit et 4K.',
		v1_max_length: 155,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En options VF, VOSTFR et gratuit.',
		v2_max_length: 153,
		v3_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'"{{titleName}}" est en streaming sur {{providerNames}}. Comparez les options VF, VOSTFR et gratuit.',
		v1_max_length: 156,
		v2_translatable:
			'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En options VF, VOSTFR et gratuit.',
		v2_max_length: 158,
		v3_translatable:
			'Regardez "{{titleName}}" légal en ligne sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}. En options VF et gratuit.',
		v1_max_length: 149,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}. En VF et gratuit.',
		v2_max_length: 152,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}. Options VF et gratuit.',
		v1_max_length: 154,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}.',
		v2_max_length: 143,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}. Mis à jour le {{lastUpdatedAt}}.',
		v3_max_length: 158,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}, et 1 autre service.',
		v1_max_length: 153,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et 1 autre.',
		v2_max_length: 156,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}, et 1 autre service.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '"{{titleName}}" est en streaming sur {{providerNames}}, et {{restCount}} autres services.',
		v1_max_length: 158,
		v2_translatable: 'Regardez "{{titleName}}" légalement en ligne sur {{providerNames}}, et {{restCount}} autres.',
		v2_max_length: 162,
		v3_translatable: 'Regardez "{{titleName}}" sur {{providerNames}}, et {{restCount}} autres services.',
		v3_max_length: 150,
	},
];
